export default __webpack_public_path__ + "static/media/soudal.ef4ce7fc.png";